export default {
  component: {
    OrderConfirmation: 'XÁC NHẬN ĐẶT LỆNH',
    OrderCancellation: 'XÁC NHẬN HỦY LỆNH',
    OTPConfirmation: 'XÁC NHẬN OTP',
    CustodyCode: 'Số lưu ký',
    SubInvestmentAccount: 'Tiểu khoản',
    Ticker: 'Mã',
    Type: 'Lệnh',
    Price: 'Giá đặt',
    Volume: ' Khối lượng đặt',
    VolumeCancel: ' Khối lượng hủy',
    Value: 'Giá trị lệnh',
    Confirm: 'Xác nhận',
    Cancel: 'Hủy',
    Contact: 'Vui lòng nhập mã OTP được gửi đến thiết bị của bạn ',
    InputOTP: 'Nhập OTP',
  },
};
